import { assertValidVersion } from "@tsparticles/engine";
import { Attractor } from "./Attractor.js";
export async function loadParticlesAttractInteraction(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addInteractor("particlesAttract", container => {
        return Promise.resolve(new Attractor(container));
    }, refresh);
}
